<template>
    <div class="wrap">
        <div class="boxCard">
            <el-card class="box-card" :body-style="{padding: '0'}">
                <div slot="header" class="clearfix">
                    <span>部门管理</span>
                </div>
                <el-form :inline="true" :model="queryParams" ref="queryParams" class="demo-form-inline">
                    <el-form-item label="部门名称" prop="deptName">
                        <el-input v-model="queryParams.deptName" placeholder="请输入部门名称" @keyup.enter.native="getClassList"></el-input>
                    </el-form-item>
                    <el-form-item label="状态" prop="status">
                        <el-select v-model="queryParams.status" placeholder="请选择状态">
                            <el-option v-for="dict in statusOptions" :key="dict.dictValue" :label="dict.dictLabel" :value="dict.dictValue" />
                        </el-select>
                    </el-form-item>
                    <el-button type="primary" @click="getClassList">查询</el-button>
                    <el-button @click="resetForm('queryParams')">重置</el-button>
                </el-form>
            </el-card>
        </div>
        <div class="tabBox">
            <el-card class="box-card" :body-style="{padding: '0'}">
                <div slot="header">
                    <span class="tabTitle">部门列表</span>
                    <el-button type="primary" @click="showDialog('1')">新增部门</el-button>
                </div>
                <!-- <el-table :data="tableData" show-header border style="width: 100%">
                    <el-table-column type="index" align="center" label="序号" />
                    <el-table-column prop="test" align="center" label="名称" />
                    <el-table-column prop="test" align="center" label="说明" />
                    <el-table-column label="操作" align="center" fixed="right" width="300">
                        <template slot-scope="scope">
                            <el-button size="mini" type="primary" @click="isShow = true">新增下级部门</el-button>
                            <el-button size="mini" type="success" @click="isShow = true">编辑</el-button>
                            <el-button size="mini" type="danger" @click="delTabItem(scope.$index, scope.row)">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table> -->

                <el-table :data="deptList" row-key="deptId" default-expand-all :tree-props="{children: 'children', hasChildren: 'hasChildren'}">
                    <el-table-column prop="deptName" label="部门名称" width="260"></el-table-column>
                    <el-table-column prop="orderNum" label="排序" width="200"></el-table-column>
                    <el-table-column prop="status" label="状态" :formatter="statusFormat" width="100"></el-table-column>
                    <el-table-column label="创建时间" align="center" prop="createTime" width="200">
                        <template slot-scope="scope">
                            <span>{{scope.row.createTime}}</span>
                            <!-- <span>{{ parseTime(scope.row.createTime) }}</span> -->
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" align="center" class-name="small-padding fixed-width">
                        <template slot-scope="scope">
                            <el-button size="mini" type="text" icon="el-icon-edit" @click="showDialog('2',scope.row)">修改</el-button>
                            <el-button size="mini" type="text" icon="el-icon-plus" @click="showDialog('3',scope.row)">新增</el-button>
                            <el-button v-if="scope.row.parentId != 0" size="mini" type="text" icon="el-icon-delete" @click="delTabItem(scope.row)">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </el-card>
            <!-- <el-pagination :current-page.sync="pageNum" :page-size="pageSize" @size-change="barSizeChange" @current-change="barCurrentChange" :page-sizes="[10, 20, 30, 40, 50]" background="" layout="sizes, prev, pager, next" :total="totalCount"></el-pagination> -->
        </div>
        <my-from-dialog :isShow="isShow" :title="dialogTitle" @cancel="closeDialog" @ok="okDialog" @closeCallBack="closeCbDialog" :scrollHeight="'300px'" :dialogWidth="'600px'" :cancelBtn="true" :okBtn="true">
            <template slot="froms">
                <el-form :model="form" :rules="rules" ref="form" label-width="80px">
                    <el-row>
                        <el-col :span="24" v-if="form.parentId !== 0">
                            <el-form-item label="上级机构" prop="parentId">
                                <treeselect v-model="form.parentId" :options="deptList" :normalizer="normalizer" placeholder="选择上级部门" />
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">

                            <el-form-item label="机构名称" prop="deptName">
                                <el-input v-model="form.deptName" placeholder="请输入部门名称" />
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="显示顺序" prop="orderNum">
                                <el-input-number v-model="form.orderNum" controls-position="right" :min="0" />
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="负责人" prop="leader">
                                <el-input v-model="form.leader" placeholder="请输入负责人" maxlength="20" />
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="联系电话" prop="phone">
                                <el-input v-model="form.phone" placeholder="请输入联系电话" maxlength="11" />
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="邮箱" prop="email">
                                <el-input v-model="form.email" placeholder="请输入邮箱" maxlength="50" />
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="部门状态" prop="status">
                                <el-radio-group v-model="form.status">
                                    <el-radio v-for="dict in statusOptions" :key="dict.dictValue" :label="dict.dictValue">{{dict.dictLabel}}</el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </template>
        </my-from-dialog>
    </div>
</template>

<script>
import myFromDialog from '@/components/common/from_dialog';
import { getDicts, handleTree, selectDictLabel } from '@/utils/index';
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";

export default {
    components: {
        myFromDialog,
        Treeselect
    },
    computed: {},
    watch: {},
    data() {
        return {
            dialogType: '',
            dialogTitle: '',
            isShow: false,
            pageNum: 1,
            pageSize: 10,
            totalCount: 0,
            queryParams: {
                deptName: '',
                status: '',
                value: '',
            },
            form: {
                parentId: '',
                status: '0',
                value: '',
            },
            deptList: [],
            deptDevList: [],
            statusOptions: [],
            deptOptions: [],
            loginData: {},
            rules: this.getRules()
        }
    },
    created() {
        this.loginData = JSON.parse(localStorage.getItem('loginData')) || {};
        this.getDictsData();
        this.getClassList();
    },
    methods: {
        resetForm(formName) {
            this.$refs[formName].resetFields();
            this.getClassList();
        },
        getDictsData() {
            getDicts('sys_normal_disable', (data) => {
                this.statusOptions = data;
            });
        },
        // 字典状态字典翻译
        statusFormat(row, column) {
            return selectDictLabel(this.statusOptions, row.status);
        },
        // 关闭弹窗
        closeDialog(data) {
            this.isShow = false;
            console.log(data);
        },
        // 确定弹窗
        okDialog(data) {
            console.log(data);
            let _this = this;
            this.$refs.form.validate(valid => {
                if (valid) {
                    if (_this.dialogType == '2') {
                        _this.editClass();
                    } else {
                        _this.addClass();
                    }
                } else {
                    _this.$message.error('提交信息不完善，请完善必填项');
                    return false;
                }
            });
            // this.isShow = false;
        },
        // 弹窗右上角关闭
        closeCbDialog(data) {
            console.log(data);
            this.isShow = false;
        },
        //显示弹窗
        showDialog(dialogType, item) {
            let _this = this;
            this.dialogType = dialogType;
            this.dialogTitle = dialogType == '2' ? '编辑部门' : '新增部门';
            this.form = {};
            if (item) {
                if (item.parentId === 0 && dialogType != '3') {
                    this.form.parentId = item.parentId;
                } else {
                    this.form.parentId = item.deptId;
                }
            }
            if (dialogType == '1') {
            } else if (dialogType == '2') {
                this.form.parentId = null;
                this.getClassListById(item.deptId, (data) => {
                    _this.form = data || {};
                })
            } else if (dialogType == '3') {
            }
            this.isShow = true;
        },
        // 当前显示条数
        barSizeChange(val) {
            this.form.pageSize = val;
            this.getPrescriptionDetailInfo();
            console.log(`每页 ${val} 条`);
        },
        // 当前页
        barCurrentChange(val) {
            this.form.pageNum = val;
            this.getPrescriptionDetailInfo();
            console.log(`当前页: ${val}`);
        },
        // 删除按钮
        delTabItem(item) {
            let _this = this;
            this.$confirm('是否确认删除名称为"' + item.deptName + '"的数据项?', "警告", {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                _this.delClass(item.deptId);
            }).catch(() => {
            });
        },
        /** 转换部门数据结构 */
        normalizer(node) {
            if (node.children && !node.children.length) {
                delete node.children;
            }
            return {
                id: node.deptId,
                label: node.deptName,
                children: node.children
            };
        },
        // 获取部门列表
        getClassList() {
            let _this = this;
            let params = { deptName: this.queryParams.deptName, status: this.queryParams.status, enterpriseId: this.loginData.enterpriseId };
            this.$https.get('system/enterpriseManager/dept/list', params).then(res => {
                _this.deptDevList = res.data;
                _this.deptList = handleTree(res.data, "deptId");
                console.log(res);
            }).catch(res => {

            })
        },
        // 根据ID查询部门信息
        getClassListById(id, cb) {
            let _this = this;
            this.$https.get('system/enterpriseManager/dept/' + id, {}).then(res => {
                // _this.deptDevList = res.data;
                cb && cb(res.data);
                // return handleTree(res.data, "deptId");
                // console.log(res);
            }).catch(res => {

            })
        },
        // 新增部门
        addClass() {
            let _this = this;
            let params = this.form;
            params.enterpriseId = this.loginData.enterpriseId;
            this.$https.post('system/enterpriseManager/dept', params).then(res => {
                _this.$message.success('新增成功');
                _this.isShow = false;
                _this.getClassList();
                // console.log(res);
            }).catch(res => {

            })
        },
        // 修改部门
        editClass() {
            let _this = this;
            let params = this.form;
            this.$https.put('system/enterpriseManager/dept', params).then(res => {
                _this.$message.success('修改成功');
                _this.isShow = false;
                _this.getClassList();
                // console.log(res);
            }).catch(res => {

            })
        },
        // 删除部门
        delClass(id) {
            let _this = this;
            this.$https.delete('system/enterpriseManager/dept/' + id, {}).then(res => {
                _this.$message.success('删除成功');
                _this.isShow = false;
                _this.getClassList();
                // console.log(res);
            }).catch(res => {

            })
        },
        // 获取角色设置校验规则
        getRules() {
            return {
                parentId: [
                    { required: true, message: "上级部门不能为空", trigger: "blur" }
                ],
                deptName: [
                    { required: true, message: "部门名称不能为空", trigger: "blur" }
                ],
                orderNum: [
                    { required: true, message: "菜单顺序不能为空", trigger: "blur" }
                ],
                status: [
                    { required: true, message: "部门状态必填", trigger: "blur" }
                ],
                email: [
                    {
                        type: "email",
                        message: "'请输入正确的邮箱地址",
                        trigger: ["blur", "change"]
                    }
                ],
                phone: [
                    {
                        pattern: /^1[3|4|5|6|7|8|9][0-9]\d{8}$/,
                        message: "请输入正确的手机号码",
                        trigger: "blur"
                    }
                ]
            }
        },
    },
}
</script>

<style lang="less" scoped>
.wrap {
    background: #fff;
}
.queryBox {
    // background: #fff;
    padding: 20px;
}
.baseInp {
    width: 300px;
}
.tabTitle {
    color: #333;
    font-size: 15px;
    margin-right: 30px;
}
</style>
